<template>
  <Toolbar class="profile-team-toolbar">
    <template #title>
      Моя команда
    </template>
    <template v-if="loaded && !team" #default>
      <AppBtn class="profile-team-toolbar__btn" @click="createTeam">
        Создать команду
      </AppBtn>
    </template>
  </Toolbar>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar/";
import { openModal as openTeamCreationModal } from "@/components/teams/TeamCreation";
import { mapState } from "vuex";

export default {
  name: "ProfileTeamToolbar",
  components: {
    Toolbar
  },
  props: {
    loaded: Boolean
  },
  computed: {
    ...mapState("team", ["team"])
  },
  methods: {
    openTeamCreationModal,

    createTeam() {
      this.openTeamCreationModal();
    }
  }
};
</script>

<style lang="scss">
.profile-team-toolbar {
  margin-bottom: 20px;

  &__btn {
    margin-left: auto;
    height: 50px;
    text-transform: uppercase;
    font-weight: fw(bold);
  }

  @include breakpoint("sm-and-down") {
    &__btn {
      margin-right: auto;
    }
  }
}
</style>
